/**
 * Training Create Page
 * Page for creating new trainings
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';
import { PageShell } from '../../components';
import { trainingService } from '../../services/trainingService';
import { TrainingFormData } from '../../types/training';
import { TrainingForm } from './components/TrainingForm';

export const TrainingCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: TrainingFormData) => {
    try {
      setLoading(true);
      setError(null);
      await trainingService.createTraining(data);
      navigate('/trainings');
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao criar treinamento';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/trainings');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Treinamentos', path: '/trainings' },
        { label: 'Novo Treinamento' },
      ]}
      title="Cadastrar Novo Treinamento"
      subtitle="Preencha os dados do treinamento ou capacitação"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <TrainingForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </PageShell>
  );
};

export default TrainingCreatePage;
